import { LitElement, html, css } from "lit";
import dayjs from "dayjs";
import language from "#scripts/translation";
import { ensureLogedin } from "#scripts/idporten.js";

export class MyPageForms extends LitElement {
  static properties = {
    yearfilter: { reflect: true },
  };

  static styles = css`
    :host {
      width: 100%;
    }
    .forms {
      display: flex;
			flex-direction: column;
      border-top: 2px solid rgba(0, 0, 0, 0.2);
      padding-top: 65px;
      margin-top: 30px;
      @media(max-width: 768px) {
        flex-direction: column;
        border-top: none;
        padding-top: 0px;
        margin-top: 0px;
      }
    }
    `;

  render () {
    return html`
        <div class="forms">
          <slot></slot>
      </div>`;
  }

  _handleYearFilter (e) {
    this.yearfilter = e.detail.message;
    // update all children that uses filter
    const formsList = document.querySelector("mypage-forms-list");
    formsList.yearfilter = this.yearfilter;
  }
}

export class MyPageFormsFilter extends LitElement {
  static properties = {
    yearfilter: { type: String, state: true, reflect: true },
    ssn: { type: String },
  };

  static styles = css`
    .filter {
      width: 240px;
      position: relative;
      padding: 0px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      @media(max-width: 768px) {
        display: none;
        gap: 20px;
        width: auto;
        border-radius: 6px;
        padding: 20px;
        background: rgb(255 255 255 / .8);
        margin-bottom: 20px;
      }
    }
    .filter-toggle {
      font-size: 1rem;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 10px;
      & div {
        display: flex;
      }
      & svg {
        position: relative;
      }
      @media(min-width: 768px) {
        display: none;
      }
      &.active svg {
        transform: rotate(180deg);
      }
      &.active + .filter {
        display: flex;
      }
    }
    .filter-header {
      color: #000000;
      font-size: var(--raelingen-h3-font-size, 20px);
      font-weight: var(--raelingen-h3-font-weight, 600);
    }
    .filter-group {
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      margin-top:  10px;
    }
    .filter-title {
      display: flex;
      height: 50px;
      align-content: center;
      flex-wrap: wrap;
    }
    .dato {
      color: #000000;
      text-align: left;
      font-family: var(--trekkspill-tekst-font-family, "Roboto-Medium", sans-serif);
      font-size: var(--trekkspill-tekst-font-size, 18px);
      line-height: var(--trekkspill-tekst-line-height, 24px);
      font-weight: var(--trekkspill-tekst-font-weight, 500);
      position: relative;
    }
    .cells {
      display: flex;
      width: 292px;
      flex-direction: column;
    
    .check-cell {
			padding: 14px 0;
      @media(min-width: 768px) {
				padding: 16px 0;
      }
		}
		
    .check {
      display: flex;
      gap: 10px;
    }
		input[type=checkbox],
    input[type=radio] {
        transform: scale(1.5);
				accent-color: var(--black__text);
    }
    `;

  // constructor() {
  // 	super();
  // }

  render () {
    return html`  
      <div class="filter-toggle" @click=${this._handleFilterToggle}>
        <div>Filter</div>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 -960 960 960" fill="var(--black__text)"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
      </div> 
      <div class="filter">
        <div class="filter-header">${language("MYPAGE_FORMS_FILTER_TITLE")}</div>
      <div class="filter-group">
        <div class="filter-title">
          <div class="dato">${language("MYPAGE_FORMS_FILTER_YEAR")}</div>
        </div>
          <div class="cells">
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck
      } data-filtervalue=${new Date().getFullYear()} checked>${new Date().getFullYear()}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 1}>${new Date().getFullYear() - 1
      }</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 2}>${new Date().getFullYear() - 2
      }</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 3}>${new Date().getFullYear() - 3
      }</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 4}>${new Date().getFullYear() - 4
      }</label>
          </div>
        </div>
        </div>
    </div>
    `;
  }

  _handleYearCheck (event) {
    const detail = {
      message: event.target.checked ? event.target.dataset.filtervalue : "",
    };
    const options = {
      detail,
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("forms-filtered-year", options));
  }

  _handleFilterToggle (event) {
    event.preventDefault();
    const link = event.target;
    link.parentElement.classList.toggle("active");
  }
}

export class MyPageFormsList extends LitElement {
  static properties = {
    listtype: { type: String },
  };

  static styles = css`
    :host {
      width: 100%;
    }

    .list__container {
      margin-inline: auto;
      padding-bottom: 30px;
      width: 100%;
      max-width: 1140px; 
      justify-content: space-between;
    }
    .list__items {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 5px;
			@media(max-width: 768px) {
        gap: 20px;
			}
    }
		.header {
			font-size: 1.5rem;
			font-weight: 600;
    }
    .list__items > div {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
    }
    .list__items > div:first-child {
      padding: 20px 34px 0;
    }
    .loader {
      align-self: center;
      width: 50px;
      padding: 8px;
      aspect-ratio: 1;
      border-radius: 50%;
      background: var(--spinner-color, var(--primary__color, #444));
      --_m: 
        conic-gradient(#0000 10%,#000),
        linear-gradient(#000 0 0) content-box;
      -webkit-mask: var(--_m);
              mask: var(--_m);
      -webkit-mask-composite: source-out;
              mask-composite: subtract;
      animation: l3 1s infinite linear;
    }
    @keyframes l3 {to{transform: rotate(1turn)}}
  `;

  // constructor() {
  //   super();
  // }

  render () {
    const listTitle = this.listtype === "submitted" ? "Innsendte skjema" : "Lagrede skjema";

    getForms().then((data) => {
      if (data?.instances !== undefined) {
        let forms = this.listtype === "submitted" ? data?.instances.submitted : data?.instances.saved;
        for (const item of forms) {
          const messageCard = document.createElement("mypage-forms-item");
          messageCard.item = item;
          this.appendChild(messageCard);
        }
        if (this.children.length < 1) {
          const messageError = document.createElement("mypage-forms-error");
          messageError.message = language("MYPAGE_FORMS_NOMESSAGES");
          this.appendChild(messageError);
        }
      } else {
        const messageError = document.createElement("mypage-forms-error");
        messageError.message = data?.message ?? data;
        this.appendChild(messageError);
      }
    });

    return html`<div class="list__container">
                  <div class="header">${listTitle}</div>
									<div class="list__items">
                    <div>
                      <div>${language("MYPAGE_FORMS_LABEL_NAME")}</div>
                      <div>${language("MYPAGE_FORMS_LABEL_FROM")}</div>
                      <div>${language("MYPAGE_FORMS_LABEL_DATE")}</div>
                    </div>
										<slot><div class="loader"></div></slot>
									</div>
								</div>`;
  }
}

export class MyPageFormsItem extends LitElement {
  static properties = {
    item: { type: Object, reflect: true },
  };

  static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px 34px;
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      flex-direction: row;
      gap: 20px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
			cursor: pointer;
			@media(max-width: 768px) {
				padding: 20px 10px 20px 20px;
			}
    }
    .icon {
      padding: 5px 0px 0px 0px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      flex-shrink: 0;
      width: 37px;
      height: auto;
      position: relative;
      img {
        width: 32px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .title {
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: center;
      flex-shrink: 0;
      position: relative;
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: var(
        --raelingen-h3-font-family,
        "SourceSansPro-SemiBold",
        sans-serif
      );
      font-size: var(--raelingen-h3-font-size, 20px);
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      position: relative;
      flex: 1;
    }
    .title a {
      color: var(--default-500, #1e1e1e)
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: "SourceSansPro-Regular", sans-serif;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: center;
    }
		`;

  // constructor() {
  //   super();
  // }

  render () {
    return html`
			<div class="item">
        <div class="title">
          <a href="https://lab.skjema.no/${this.item.customerId}/cases/${this.item.refId}">${this.item.name}</a>
        </div>
        <div class="text">
          ${this.item.customerName}
        </div>
        <div class="text">
          ${dayjs(this.item.createdOn).format("DD MMM YYYY")}
        </div>		
      </div>
			`;
  }

}

export class MyPageFormsError extends LitElement {
  static properties = {
    message: { type: String },
  };

  static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px 25px 20px 25px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
    }
    .icon {
      padding: 5px 0px 0px 0px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      flex-shrink: 0;
      width: 37px;
      height: auto;
      position: relative;
      img {
        // width: 32px;
        height: 50px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .title {
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: var(
        --raelingen-h3-font-family,
        "SourceSansPro-SemiBold",
        sans-serif
      );
      font-size: var(--raelingen-h3-font-size, 20px);
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      position: relative;
      flex: 1;
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: "SourceSansPro-Regular", sans-serif;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: stretch;
    }
    .more-icon {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-end;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .arrow-forward {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      position: relative;
      overflow: visible;
    }
    .pill {
      background: #eeeeee;
      border-radius: 40px;
      padding: 4px 11px 4px 11px;
    }
    .amount {
      font-weight: 600;
    }
    .paid {
      background: #d6f3c0;
    }`;

  // constructor() {
  //   super();
  // }

  render () {
    return html`${this.message}`;
  }
}

customElements.define("mypage-forms", MyPageForms);
customElements.define("mypage-forms-filter", MyPageFormsFilter);
customElements.define("mypage-forms-list", MyPageFormsList);
customElements.define("mypage-forms-item", MyPageFormsItem);
customElements.define("mypage-forms-error", MyPageFormsError);

const getForms = async (year) => {
  if (!window.location.host.match(/localhost/gim)) {
    return ensureLogedin().then(async (accessToken) => {
      if (window.serverdata?.configMeta?.aim?.mysite?.forms?.provider === 'skjema') {
        // use skjema.no API
        const apiUrl = "https://api.skjema.no/ralingen";
        const apiParameters = `?fra=0&antall=25&sortering=DATO_DESC&akseptertMeldingVersjon=forsendelseV2`;
        const body = {
          fraDato: `${year}-01-01`,
          tilDato: `${year}-12-31`,
        };

        return await fetch(apiUrl + apiParameters, {
          method: "FORMS",
          headers: {
            "Content-Type": "application/json",
            SubscriptionId: `${window.serverdata.configMeta.aim.clientId}`,
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(body),
        })
          .then((results) => {
            if (results.ok) {
              return results.json();
            }
            return results.text();
          })
          .then((data) => {
            return data;
          })
          .catch((error) => {
            console.log(error.status, error.statusText);
          });
      }
      else {
        // default forms is KS Fiks
        const fiksOrgId = window.serverdata.configMeta?.integrations?.fiksOrgId;
        const apiUrl = window.apiUrl.replace("/api", "/proxy");
        const apiCall = `${apiUrl}/ksfiks/innsyn/post/sok`;
        const apiParameters = "?fra=0&antall=25&sortering=DATO_DESC&akseptertMeldingVersjon=forsendelseV2";
        const body = {
          fraDato: `${year}-01-01`,
          tilDato: `${year}-12-31`,
          fiksOrganisasjon: [fiksOrgId],
        };

        return await fetch(apiCall + apiParameters, {
          method: "FORMS",
          headers: {
            "Content-Type": "application/json",
            SubscriptionId: `${window.serverdata.configMeta.aim.clientId}`,
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(body),
        })
          .then((results) => {
            if (results.ok) {
              return results.json();
            }
            return results.text();
          })
          .then((data) => {
            return data;
          })
          .catch((error) => {
            console.log(error.status, error.statusText);
          });
      }
    });

  }

  // For local development, return mock data
  return JSON.parse(`
			{
  "instances": {
    "submitted": [
      {
        "name": "Summering Avansert",
        "formId": "sum-01",
        "refId": "YKKADD",
        "createdOn": "2025-01-16 13:17:14",
        "updatedOn": "2025-01-16 13:17:59",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Kart-test",
        "formId": "kart-test-01",
        "refId": "WIVLPQ",
        "createdOn": "2025-01-14 09:57:06",
        "updatedOn": "2025-01-14 09:58:52",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Summering Avansert",
        "formId": "sum-01",
        "refId": "THOJZN",
        "createdOn": "2025-01-13 13:02:38",
        "updatedOn": "2025-01-13 13:03:03",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Kart-test",
        "formId": "kart-test-01",
        "refId": "ZKPJMQ",
        "createdOn": "2025-01-13 12:59:55",
        "updatedOn": "2025-01-13 13:01:06",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Summering",
        "formId": "sum-1",
        "refId": "FOJJHW",
        "createdOn": "2025-01-10 13:35:33",
        "updatedOn": "2025-01-10 13:35:43",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Kart-test",
        "formId": "kart-test-01",
        "refId": "SQCQDS",
        "createdOn": "2025-01-10 13:32:54",
        "updatedOn": "2025-01-10 13:34:18",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Kart-test",
        "formId": "kart-test-01",
        "refId": "QWUIKK",
        "createdOn": "2024-10-07 14:51:41",
        "updatedOn": "2024-10-07 14:52:59",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      }
    ],
    "saved": [
      {
        "name": "Summering",
        "formId": "sum-1",
        "refId": "XQCLQN",
        "createdOn": "2025-01-16 14:30:29",
        "updatedOn": "2025-01-16 14:39:41",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Verdioverføring",
        "formId": "value-transfer",
        "refId": "CJHJUQ",
        "createdOn": "2025-01-16 13:18:52",
        "updatedOn": "2025-01-16 13:19:04",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Summering Avansert",
        "formId": "sum-01",
        "refId": "RPUZPJ",
        "createdOn": "2025-01-15 11:05:44",
        "updatedOn": "2025-01-15 11:06:33",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Summering",
        "formId": "sum-1",
        "refId": "GHWHTM",
        "createdOn": "2025-01-07 12:56:00",
        "updatedOn": "2025-01-07 13:16:30",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Summering",
        "formId": "sum-1",
        "refId": "LBGBRP",
        "createdOn": "2025-01-07 12:54:04",
        "updatedOn": "2025-01-07 12:54:33",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Summering",
        "formId": "sum-1",
        "refId": "BJUSMD",
        "createdOn": "2025-01-06 13:55:21",
        "updatedOn": "2025-01-06 14:15:28",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Verdioverføring",
        "formId": "value-transfer",
        "refId": "BROFKS",
        "createdOn": "2024-12-18 15:00:02",
        "updatedOn": "2025-01-03 15:25:08",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Verdioverføring",
        "formId": "value-transfer",
        "refId": "EGUQXG",
        "createdOn": "2024-12-17 13:03:53",
        "updatedOn": "2024-12-17 13:04:01",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Bjørn noark4",
        "formId": "bjornnoark4",
        "refId": "DUMMYM",
        "createdOn": "2024-12-17 13:02:46",
        "updatedOn": "2024-12-17 13:03:16",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      },
      {
        "name": "Verdioverføring",
        "formId": "value-transfer",
        "refId": "LYPMJH",
        "createdOn": "2024-12-16 14:12:19",
        "updatedOn": "2024-12-16 14:12:30",
        "customerId": "9998",
        "customerName": "Sem & Stenersen Prokom"
      }
    ]
  }
}
		`);
};
